<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <div class="tercero-table-block mt-4" v-if="tipoContrato?.length > 0">
            <CorporateDataTable
                :items="tipoContrato"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => editTipoContrato(item.id)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createTipoContrato()">
                        {{ labels.addTipoContrato }}
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modalCrear="showTipoContrato" @creado="actualizarTabla" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showEditTipoContrato" :infoEdit="dataTipoContrato" @actualizado="actualizarTabla" @eliminado="actualizarTabla" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>

import TipoContrato from '../../../services/TipoContrato'
import CorporateDataTable from '../../utils/CorporateDataTable.vue' 
import Crear from './Crear' 
import Editar from './Editar' 

export default {
    name:'TipoContrato',
    components:{Crear,Editar,CorporateDataTable},
    data:() => ({
        tipoContrato : [],
        showTipoContrato : false,
        showEditTipoContrato : false,
        dataTipoContrato : []
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Tipo contrato",
                    codigo : "Código",
                    descripcion : "Descripción",
                    noRow : "No hay registros",
                    addTipoContrato : "Añadir tipo contrato",
                    filterCodigo : "Filtrar código...",
                    filterDescripcion : "Filtrar descripción...",
                }
            }else{
                return {
                    title: "Contract type",
                    codigo : "Code",
                    descripcion : "Description",
                    noRow : "There are not records",
                    addTipoContrato : "Add contract type",
                    filterCodigo : "Filter code...",
                    filterDescripcion : "Filter description...",
                }
            }
        },
        allFields(){
            return [
                { key: 'tipo_contrato', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-center', tdClass: 'text-center' }
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'tipo_contrato', type: 'text', placeholder: this.labels.filterCodigo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion }
            ]
        },
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        createTipoContrato(){
            this.showTipoContrato = true 
        },
        editTipoContrato(id){
            // console.log('editTipoContrato',id); 
            TipoContrato.getTipoContratoById(id) 
            .then((res) => { 
                // console.log(res.data.tipoContrato); 
                this.dataTipoContrato = res.data.tipoContrato 
                this.showEditTipoContrato = true 
            })
            .catch((error) => { console.log(error);}) 
        },
        closeModal(val){
            this.showTipoContrato = val 
            this.showEditTipoContrato = val 
        },
        actualizarTabla(){
            TipoContrato.getAllTipoContrato() 
            .then((res) => { 
                // console.log(res.data.listTipoContrato) 
                this.tipoContrato = res.data.listTipoContrato 
            })
            .catch((err) => { console.log(err)})
        }
    },
    mounted(){
        TipoContrato.getAllTipoContrato() 
        .then((res) => { 
            console.log(res.data.listTipoContrato) 
            this.tipoContrato = res.data.listTipoContrato 
        })
        .catch((err) => { console.log(err)}) 
    }
}
</script>

<style>

</style>
